export default "__VITE_ASSET__wdyJeOcb__"